import axios from "axios";
import { store } from "../redux/store";
import { logout, updateTokens } from "../redux/auth/authSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("access_token") ||
      store.getState()?.auth?.access_token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refresh_token");
        if (!refreshToken) {
          store.dispatch(logout());
          window.location.href = "/";
          return Promise.reject(error);
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/auth/refresh-token/`,
          { token: refreshToken }
        );

        const newToken =
          response.data.data?.token || response.data?.token;

        if (newToken) {
          store.dispatch(updateTokens({ access_token: newToken, refresh_token: refreshToken }));
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }

        throw new Error("No token received");
      } catch (refreshError) {
        store.dispatch(logout());
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

const service = {
  get: (url, params = {}, config = {}) => api.get(url, { params, ...config }),
  post: (url, data = {}, config = {}) => api.post(url, data, config),
  put: (url, data = {}, config = {}) => api.put(url, data, config),
  patch: (url, data = {}, config = {}) => api.patch(url, data, config),
  delete: (url, config = {}) => api.delete(url, config),
  upload: (url, data, config = {}) =>
    api.post(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
      ...config,
    }),
  download: (url, config = {}) =>
    api.get(url, { responseType: "blob", ...config }),
};

export default service;
